import 'rc-drawer/assets/index.css'
import React from 'react'
import DrawerMenu from 'rc-drawer'
import { MenuLeft } from './MenuLeft'
import { MenuTop } from './MenuTop'
import { connect } from 'react-redux'
import { setLayoutState } from 'reducers'
import './style.scss'

const mapStateToProps = (state, props) => {
  console.log(state.get('app').layoutState)
  const layoutState = state.get('app').get('layoutState').toJS()
  return { open: layoutState.menuMobileOpened, isMenuTop: layoutState.isMenuTop }
}

@connect(mapStateToProps)
class AppMenu extends React.Component {
  state = {
    open: this.props.open,
    isMenuTop: this.props.isMenuTop,
  }

  toggleOpen = () => {
    const { dispatch } = this.props
    const { open } = this.state
    dispatch(setLayoutState({ menuMobileOpened: !open }))
  }

  componentWillReceiveProps({ open, isMenuTop }) {
    this.setState({
      open,
      isMenuTop,
    })
  }

  render() {
    const { isMobile } = this.props
    const { open, isMenuTop } = this.state

    return isMobile ? (
      <DrawerMenu
        getContainer={null}
        level={null}
        open={open}
        onMaskClick={this.toggleOpen}
        onHandleClick={this.toggleOpen}
      >
        <MenuLeft {...this.props} />
      </DrawerMenu>
    ) : isMenuTop ? (
      <MenuTop {...this.props} />
    ) : (
      <MenuLeft {...this.props} />
    )
  }
}

export default AppMenu



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/index.js